import { extractData } from '@/utils'
import { reportUrls } from '@/api/urls'
import { extractIsInEditMode } from '@/data-extraction/reports'
import axios from 'axios'

const headers = { headers: {'Content-Type': 'application/json'}, withCredentials: true }

const getReport = (userId, managerId, start, count, refresh) => {
  return axios.post(reportUrls.getReport(userId, start, count, refresh), {
    ManagerId: managerId
  }, headers).then(extractData)
}

const saveSession = (userId, managerId) => {
  return axios.post(reportUrls.saveSession(userId, managerId), JSON.stringify(''), headers).then(extractData)
}

const switchModes = (userId, managerId) => {
  return axios.post(reportUrls.switchModes(userId, managerId), JSON.stringify(''), headers).then(extractData)
}

const switchToReadOnlyMode = async (userId, managerId) => {
  let report = await getReport(userId, managerId, 0, 1, false)
  if (extractIsInEditMode(report)) {
    await switchModes(userId, managerId)
  }
}

const openReport = async ({userId, managerId, start, count}) => {
  let report = await getReport(userId, managerId, start, count, true)
  if (!extractIsInEditMode(report)) {
    await switchModes(userId, managerId)
    report = await getReport(userId, managerId, start, count, true)
  }
  return report
}

export default {
  getReport,
  saveSession,
  switchModes,
  openReport,
  switchToReadOnlyMode
}
